import classnames from 'classnames';
import React__default from 'react';
import '../box/index.js';
import { footer } from './modal.css.js';
import { Box } from '../box/box.js';

const ModalFooter = ({ children, className }) => {
    return (React__default.createElement(Box, { padding: "medium", className: classnames(footer, className) }, children));
};

export { ModalFooter };
